var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonYellowRightLayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 56,
    viewBox: "0 0 16 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6536 47.9887C7.3266 49.7272 7.3693 52.0602 7.4682 53.7601C7.5378 54.9549 6.6023 55.9998 5.4055 55.9998H0.5V0H5.4057C6.6025 0 7.5379 1.0449 7.4684 2.2397C7.3695 3.9395 7.3268 6.2726 7.6538 8.0111C7.898 9.3095 8.0728 10.0399 8.5369 11.2777C9.3497 13.4452 11.3959 14.1006 11.51 16.411C11.6017 18.2684 9.975 20.9218 9.975 20.9218C9.975 20.9218 12.0189 21.3323 12.8478 22.2442C13.8779 23.3775 12.932 24.7511 13.7315 26.0555C14.2557 26.9106 15.5002 27.9221 15.5002 27.9221C15.5002 27.9221 14.2511 29.0599 13.732 29.9834C13.0261 31.2392 13.7702 32.452 12.8481 33.5608C12.0386 34.5343 9.9747 35.0778 9.9747 35.0778C9.9747 35.0778 11.6017 37.7312 11.51 39.5887C11.396 41.8992 9.3498 42.5546 8.5369 44.7221C8.0727 45.9598 7.8979 46.6902 7.6536 47.9887Z",
    fill: "#FAD300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonYellowRightLayer);
export default __webpack_public_path__ + "static/media/button-yellow-right-layer.3c895923123a76c27c4a4b71095f70f4.svg";
export { ForwardRef as ReactComponent };